import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-50 border-t border-primary-100 mt-auto">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-play-fill"></i>
              </span>
              <span className="text-2xl text-primary-600 font-brand leading-none">快手</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              记录每一种生活，发现每一份热爱。快手是聚焦热门短视频内容与创作社区的综合短视频平台，让每一个精彩瞬间都被看见。
            </p>
            <div className="flex items-center gap-3 mt-4">
              {["ri-wechat-line", "ri-weibo-line", "ri-video-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">
              <Link to="/" className="hover:text-primary-600 transition-colors">
                热门分类
              </Link>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">
              <Link to="/about" className="hover:text-primary-600 transition-colors">
                关于与帮助
              </Link>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  平台介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  使用条款
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  隐私政策
                </Link>
              </li>
              <li>
                <Link to="/creator" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  创作者指南
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-100 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 快手短视频平台 · 本网站为功能演示，内容均为示例数据
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              服务条款
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}